module.exports = __webpack_public_path__ + "img/ctrl-u2-1.553b9134.svg";